// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/user/styles/Avatar.scss
// module id = 1350
// module chunks = 0